import { useEffect, useState } from 'react';
import '../styles/components/Modal.scss';
import { FiX, FiCheck } from 'react-icons/fi';

const Modal = ({ 
  isOpen, 
  onClose, 
  title, 
  message, 
  type = 'success',
  autoClose = true,
  autoCloseTime = 3000,
  showCloseButton = true,
  children 
}) => {
  const [progress, setProgress] = useState(100);

  useEffect(() => {
    if (isOpen && autoClose) {
      // Reset progress when modal opens
      setProgress(100);
      
      const interval = setInterval(() => {
        setProgress(prev => Math.max(prev - (100 / (autoCloseTime / 50)), 0));
      }, 50);

      const timer = setTimeout(() => {
        onClose();
        clearInterval(interval);
      }, autoCloseTime);

      return () => {
        clearTimeout(timer);
        clearInterval(interval);
      };
    }
  }, [isOpen, autoClose, autoCloseTime, onClose]);

  if (!isOpen) return null;

  const getIcon = () => {
    switch (type) {
      case 'success':
        return <FiCheck className="modal-icon success" />;
      case 'error':
        return <FiX className="modal-icon error" />;
      case 'warning':
        return <span className="modal-icon warning">⚠️</span>;
      default:
        return null;
    }
  };

  const getColor = () => {
    switch (type) {
      case 'success':
        return '#38a169';
      case 'error':
        return '#e53e3e';
      case 'warning':
        return '#d69e2e';
      default:
        return '#3182ce';
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal">
        {autoClose && (
          <div 
            className="modal-progress" 
            style={{ 
              width: `${progress}%`,
              backgroundColor: getColor()
            }}
          />
        )}
        
        <div className="modal-content">
          {getIcon()}
          
          {title && <h3 className="modal-title">{title}</h3>}
          
          {message && <p className="modal-message">{message}</p>}
          
          {children}
        </div>

        {showCloseButton && (
          <button 
            className="modal-close"
            onClick={onClose}
            aria-label="Fermer"
          >
            <FiX />
          </button>
        )}
      </div>
    </div>
  );
};

export default Modal;